/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Intermediary
 */
export interface Intermediary {
    /**
     * 
     * @type {string}
     * @memberof Intermediary
     */
    intermediaryId: string;
    /**
     * 
     * @type {string}
     * @memberof Intermediary
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof Intermediary
     */
    isAdvising: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Intermediary
     */
    isServicing: boolean;
    /**
     * 
     * @type {number}
     * @memberof Intermediary
     */
    initialFeePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof Intermediary
     */
    initialFeePercentageSplit?: number;
    /**
     * 
     * @type {number}
     * @memberof Intermediary
     */
    recurringFeeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof Intermediary
     */
    recurringFeePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof Intermediary
     */
    recurringFeePercentageSplit?: number;
    /**
     * 
     * @type {number}
     * @memberof Intermediary
     */
    annualFeePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof Intermediary
     */
    annualFeePercentageSplit?: number;
}

/**
 * Check if a given object implements the Intermediary interface.
 */
export function instanceOfIntermediary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "intermediaryId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "isAdvising" in value;
    isInstance = isInstance && "isServicing" in value;

    return isInstance;
}

export function IntermediaryFromJSON(json: any): Intermediary {
    return IntermediaryFromJSONTyped(json, false);
}

export function IntermediaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Intermediary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intermediaryId': json['IntermediaryId'],
        'name': json['Name'],
        'isAdvising': json['IsAdvising'],
        'isServicing': json['IsServicing'],
        'initialFeePercentage': !exists(json, 'InitialFeePercentage') ? undefined : json['InitialFeePercentage'],
        'initialFeePercentageSplit': !exists(json, 'InitialFeePercentageSplit') ? undefined : json['InitialFeePercentageSplit'],
        'recurringFeeAmount': !exists(json, 'RecurringFeeAmount') ? undefined : json['RecurringFeeAmount'],
        'recurringFeePercentage': !exists(json, 'RecurringFeePercentage') ? undefined : json['RecurringFeePercentage'],
        'recurringFeePercentageSplit': !exists(json, 'RecurringFeePercentageSplit') ? undefined : json['RecurringFeePercentageSplit'],
        'annualFeePercentage': !exists(json, 'AnnualFeePercentage') ? undefined : json['AnnualFeePercentage'],
        'annualFeePercentageSplit': !exists(json, 'AnnualFeePercentageSplit') ? undefined : json['AnnualFeePercentageSplit'],
    };
}

export function IntermediaryToJSON(value?: Intermediary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IntermediaryId': value.intermediaryId,
        'Name': value.name,
        'IsAdvising': value.isAdvising,
        'IsServicing': value.isServicing,
        'InitialFeePercentage': value.initialFeePercentage,
        'InitialFeePercentageSplit': value.initialFeePercentageSplit,
        'RecurringFeeAmount': value.recurringFeeAmount,
        'RecurringFeePercentage': value.recurringFeePercentage,
        'RecurringFeePercentageSplit': value.recurringFeePercentageSplit,
        'AnnualFeePercentage': value.annualFeePercentage,
        'AnnualFeePercentageSplit': value.annualFeePercentageSplit,
    };
}

